import React from 'react';
import style from './Teammate.module.css';

function Teammate({photo, name, surname, role}) {
    return (
        <div className={style.main}>
            <div className={style.photo}>
                <img src={photo} alt="" />
            </div>

            <div className={style.name}>
                {name}
            </div>

            <div className={style.name}>
                {surname}
            </div>

            <div className={style.role}>
                {role}
            </div>
        </div>
    );
}

export default Teammate;